/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S8_Li4_DescInputs */

const tr_iade_iptal_s8_li4_desc = /** @type {(inputs: Iade_Iptal_S8_Li4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adli veya idari makam talebi, yasal düzenleme değişikliği nedeniyle hizmetin sunulamaması.`)
};

const en_iade_iptal_s8_li4_desc = /** @type {(inputs: Iade_Iptal_S8_Li4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request of a judicial or administrative authority, inability to provide the service due to a change in legal regulation.`)
};

const de_iade_iptal_s8_li4_desc = /** @type {(inputs: Iade_Iptal_S8_Li4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anordnung einer Justiz- oder Verwaltungsbehörde, Unmöglichkeit der Leistungserbringung aufgrund einer Änderung der Rechtslage.`)
};

const ru_iade_iptal_s8_li4_desc = /** @type {(inputs: Iade_Iptal_S8_Li4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требование судебного или административного органа, невозможность оказания услуги вследствие изменения правового регулирования.`)
};

/**
* | output |
* | --- |
* | "Request of a judicial or administrative authority, inability to provide the service due to a change in legal regulation." |
*
* @param {Iade_Iptal_S8_Li4_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s8_li4_desc = /** @type {((inputs?: Iade_Iptal_S8_Li4_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S8_Li4_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s8_li4_desc(inputs)
	if (locale === "de") return de_iade_iptal_s8_li4_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s8_li4_desc(inputs)
	return tr_iade_iptal_s8_li4_desc(inputs)
});